import { APP_POOL_CONFIG } from '@synergy/config';
import { Box } from '@mui/material';
import { PoolButton } from '@synergy/components-next';
import { PoolFormattedMessage } from '@synergy/components-next';
import { ReactElement } from 'react';
import { ShoppingCartIcon, SortingArrowLeftIcon } from '@synergy/theme-next';
import { useNavigate } from 'react-router';

import { EmptyState } from '../../../components/empty-state/empty-state';
import { EmptyStateActions } from '../../../components/empty-state/empty-state-actions';
import { EmptyStateContent } from '../../../components/empty-state/empty-state-content';
import { EmptyStateTitle } from '../../../components/empty-state/empty-state-title';

export const ShoppingCartEmpty = (): ReactElement => {
    const navigate = useNavigate();

    const handleBackToShopClick = (): void => {
        navigate('/');
    };

    return (
        <Box sx={{ py: 22, margin: 'auto' }}>
            <EmptyState icon={<ShoppingCartIcon fontSize="inherit" />}>
                <EmptyStateTitle>
                    <PoolFormattedMessage id="app.cart.empty.title" />
                </EmptyStateTitle>
                <EmptyStateContent>
                    <PoolFormattedMessage
                        id="app.cart.empty.content"
                        values={{ poolConfigNameShort: APP_POOL_CONFIG['name_short'] }}
                    />
                </EmptyStateContent>
                <EmptyStateActions>
                    <PoolButton
                        variant="contained"
                        startIcon={<SortingArrowLeftIcon />}
                        onClick={handleBackToShopClick}
                    >
                        <PoolFormattedMessage id="app.empty.button.backToShop" />
                    </PoolButton>
                </EmptyStateActions>
            </EmptyState>
        </Box>
    );
};
